import type { EmbedStyle, WidgetBackgroundStyle } from "@/types/ui/branding";
import type { ChatAppearanceProps } from "@/types/voice/chat-appearance";
import { isDarkBackground, widgetBackgroundToCss } from "@/lib/widgetBackgroundPresets";

/** The popup widget's body background: its preset, or the legacy single colour. */
export const popupBackground = (embedStyle?: EmbedStyle | null): WidgetBackgroundStyle | null =>
  embedStyle?.background ??
  (embedStyle?.widgetBackgroundColor ? { type: "solid", color: embedStyle.widgetBackgroundColor } : null);

/** Keep storage selection outside the renderers so a unified editor can reuse
 * the same presentation contract without migrating every chat surface.
 * `popupFallback` fills in what the full page never set — Studio passes it
 * only when embedded, so a regular page keeps its own defaults. */
export const fullPageChatAppearance = (
  embedStyle?: EmbedStyle,
  logoUrl?: string | null,
  popupFallback?: EmbedStyle | null,
): ChatAppearanceProps => {
  const style = embedStyle?.fullPageStyle;
  const background = style?.background ?? embedStyle?.fullPageBackground ?? popupBackground(popupFallback);
  const chatStyle = style?.chatStyle ?? popupFallback?.chatStyle;
  return {
    welcomeLayout: "page",
    logoUrl,
    chatStyle,
    inputBackgroundColor: chatStyle?.inputBackgroundColor,
    actionButtonStyle: style?.actionButtons ?? popupFallback?.actionButtons,
    backgroundStyle: background ? widgetBackgroundToCss(background, "#FFFFFF") : undefined,
    welcomeTextColor: style?.welcomeTextColor,
    darkSurface: isDarkBackground(background),
  };
};
